import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Scheduling Module Service Stores
 */
export const schedulingStores: ServiceStoreConfig[] = [
  {
    name: "scheduling-day",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "dates/holidays",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "schedule-generator",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
];